import React from 'react';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import type { ParagraphTimelineItem as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTimelineItemProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphTimelineItem: React.FC<ParagraphTimelineItemProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();
  const date = paragraph.field_date_string?.[0]?.value;
  const subParagraph = paragraph.field_paragraph?.[0];

  return (
    <li className="ParagraphTimelineItem">
      {date && (
        <Container>
          <div className="row">
            <div className="col-12">
              <div className="ParagraphTimelineItem__date">{date}</div>
            </div>
          </div>
        </Container>
      )}
      <div className="ParagraphTimelineItem__content">
        <span className="ParagraphTimelineItem__node" aria-hidden="true" />
        {subParagraph?.entity && (
          <div className="ParagraphTimelineItem__paragraph">
            <Paragraph
              id={subParagraph.target_id}
              entity={Immutable.fromJS(subParagraph.entity)}
              headingTag="h3"
              displayMode="slider"
              textColClass="col-12"
              mediaColClass="col-12"
            />
          </div>
        )}
      </div>
    </li>
  );
};

export default ParagraphTimelineItem;
